import { JobPosition } from '@pflegia/types/api/job-position/job-position';
import { JOB_POSITION_FEATURES_EVENT_PROPERTIES, JobPositionFeatures } from '@pflegia/types/common/job-position/features';

export const getFeaturesEventPayload = (jobPosition: Pick<JobPosition, 'id' | 'jobTitles'>, featuresBadges?: JobPositionFeatures) => {
  const badges = JOB_POSITION_FEATURES_EVENT_PROPERTIES.reduce((acc, { key, property }) => {
    if (featuresBadges?.[key]) acc.push(property);
    return acc;
  }, [] as string[]);

  /* eslint-disable eslint-compat/camelcase */
  return {
    job_id: jobPosition.id,
    job_title: jobPosition.jobTitles?.map(jobTitle => jobTitle.title),
    badges,
    is_badges_eligible: badges.length > 0,
    badges_shown: badges.length > 0,
  };
  /* eslint-enable eslint-compat/camelcase */
};
